import { Grid, Typography, Card, CardContent, Box } from '@mui/material';
import { PieChart, BarChart, AttachMoney, TrendingUp } from '@mui/icons-material';

const StrategySection = () => {
  const features = [
    {
      icon: <PieChart fontSize="large" color="primary" />,
      title: "Diversified Portfolio",
      description: "Ownership in 20+ distinct private market managers across sectors and geographies"
    },
    {
      icon: <BarChart fontSize="large" color="primary" />,
      title: "Attractive Cash Flows",
      description: "Robust yield from management fees, carried interest and balance sheet returns"
    },
    {
      icon: <AttachMoney fontSize="large" color="primary" />,
      title: "Downside Protection",
      description: "80% of capital recouped through contractually-obligated management fees"
    },
    {
      icon: <TrendingUp fontSize="large" color="primary" />,
      title: "Upside Potential",
      description: "Growth of enterprise value as managers scale their AUM and performance"
    }
  ];

  return (
    <Box sx={{ py: 8, backgroundColor: '#f9f9f9', padding: 10 }}>
      <Typography variant="h3" component="h2" align="center" sx={{ mb: 6, fontWeight: 'bold' }}>
        The GP Stakes Advantage
      </Typography>
      <Grid container spacing={4} justifyContent="center">
        {features.map((feature, index) => (
          <Grid item xs={12} sm={6} md={3} key={index}>
            <Card sx={{ height: '100%', boxShadow: 3 }}>
              <CardContent sx={{ textAlign: 'center', p: 4 }}>
                <Box sx={{ mb: 2 }}>
                  {feature.icon}
                </Box>
                <Typography variant="h5" component="h3" gutterBottom>
                  {feature.title}
                </Typography>
                <Typography variant="body1" color="text.secondary">
                  {feature.description}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default StrategySection;
